module.exports = __webpack_public_path__ + "static/media/signature-ray-black.a70385f7.svg";